import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
  Typography,
  Stack,
} from '@mui/material';
import { ExportReferrers } from '../../database/referrers';
import { $TSFixMe } from '@calefy-inc/utilityTypes';
import { UnconnectedCalendar } from '../../../../pages/dashboard/UnconnectedCalendar';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: 96,
  height: 'auto',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  justifyContent: 'space-between',
  padding: theme.spacing(1, 1, 1, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  // @ts-expect-error
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    // @ts-expect-error
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

interface QuoteListToolbarProps {
  filterName: $TSFixMe;
  onFilterName: $TSFixMe;
  isLoading: $TSFixMe;
  generatingPdf: $TSFixMe;
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  isDateFilterLoading?: boolean;
}
export default function QuoteListToolbar({
  filterName,
  onFilterName,
  isLoading,
  generatingPdf,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  isDateFilterLoading = false,
}: QuoteListToolbarProps) {
  return (
    <RootStyle>
      <SearchStyle
        value={filterName}
        onChange={onFilterName}
        placeholder='Search applications...'
        aria-label='Search applications'
        startAdornment={
          <InputAdornment position='start'>
            <Box
              component={Icon}
              icon={searchFill}
              sx={{ color: 'text.disabled' }}
            />
          </InputAdornment>
        }
      />
      <Stack direction='row' spacing={1} alignItems='center'>
        <UnconnectedCalendar
          label='Start Date'
          value={startDate}
          onChange={onStartDateChange}
          maxDate={endDate ?? undefined}
        />
        <UnconnectedCalendar
          label='End Date'
          value={endDate}
          onChange={onEndDateChange}
          minDate={startDate ?? undefined}
        />
        {isDateFilterLoading && (
          <CircularProgress size='1.5rem' data-testid='date-filter-loading' />
        )}
      </Stack>
      <span></span>
      <ExportReferrers />
      {isLoading && (
        <CircularProgress size='1.5rem' data-testid='search-quotes-loading' />
      )}
      {generatingPdf && (
        <Stack direction={'row'} spacing={2}>
          <Typography color='textSecondary' variant='body2'>
            Generating Pdf
          </Typography>
          <CircularProgress size='1.5rem' />
        </Stack>
      )}
    </RootStyle>
  );
}
